export default "__VITE_ASSET__Cepi1Gug__"